export const theme = {
  color: {
    primary: '#0F9C8B',
    primaryTransparent: 'rgba(15, 156, 139, 0.15)',
    primaryLight: 'rgba(236, 247, 246, 1)',
    primaryHover: '#FFFFFF',
    primaryForeground: '#FFFFFF',
    primaryForegroundHover: '#0F9C8B',
    primaryLightBackground: '#F1F9F8',

    primaryBright: 'rgba(0, 182, 122, 1)',
    primaryBrightTransparent: 'rgba(0, 182, 122, .15)',

    secondary: '#6c757d',
    secondaryHover: '#5a6268',
    secondaryForeground: '#FFFFFF',
    secondaryForegroundHover: '#d0d0d0',

    tertiary: '#6c757d',
    white: '#FFFFFF',

    offWhite: '#fcfcfc',
    offWhiteHover: '#f5f5f5',

    muted: '#7d7d7d',
    mutedHover: '#696666',

    black: '#101010',

    disabled: '#6c757d',
    borderColor: '#ced4da',
    bodyTextColor: '#133751',
    bodyTextColorLight: 'rgba(9, 105, 174, 0.15)',
    highlightTextColor: '#007bff',
    error: '#dc3545',
    errorLight: 'rgba(220, 53, 69, 0.15)',

    secondaryGradient:
      'radial-gradient(144.31% 64.89% at 50.89% 84%, rgba(15, 156, 139, 0.08) 0%, rgba(217, 217, 217, 0.00) 100%);',
  },

  radius: {
    sm: '3px',
    md: '7px',
    lg: '16px',
    xl: '24px',
  },
} as const;

export type ThemeType = typeof theme;
export type ThemeColor = keyof ThemeType['color'];
